const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case "GET_SEARCH_SUCCESS":
      return { ...state, ...action.search }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/data/search/reducer.js